import { Injectable } from "@angular/core";
import { MCFormisForm, MCEnvironmentsService, MCSectionSchema, MCStore } from "@maslul/common-services";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { Observable } from "rxjs";

export class DeclarationsStoreData {

    formisForm: MCFormisForm | undefined;
    formisFormModel: any;
    formisFormFields: Array<FormlyFieldConfig> | undefined;
    fieldsSchema: Array<MCSectionSchema> | undefined;

}
const DECLARATIONS_DETAILS: DeclarationsStoreData =
{
    formisForm: undefined,
    formisFormModel: {},
    formisFormFields: undefined,
    fieldsSchema: undefined

}

@Injectable({
    providedIn: 'root',
})
export class DeclarationsStore extends MCStore<DeclarationsStoreData> {

    constructor(protected override environmentsService: MCEnvironmentsService) {
        super('', DECLARATIONS_DETAILS, environmentsService);
    }


    getFormisForm(): Observable<MCFormisForm | undefined> {
        return this.select(s => s.formisForm);
    }

    setFormisForm(formisForm: MCFormisForm) {
        this.updateState('[Declarations MCStore Service] set formisForm', { formisForm })
    }

    getFormisFormModel(): Observable<any> {
        return this.select(s => s.formisFormModel);
    }

    setFormisFormModel(formisFormModel: any) {
        this.updateState('[Declarations Details MCStore Service] set formisForm model', { formisFormModel: formisFormModel })
    }

    getFormisFormFields(): Observable<Array<FormlyFieldConfig> | undefined> {
        return this.select(s => s.formisFormFields);
    }

    setFormisFormFields(formisFormFields: Array<FormlyFieldConfig>) {
        this.updateState('[Declarations Details MCStore Service] set formisForm Fields', { formisFormFields: formisFormFields })
    }
    getFieldsSchema(): Observable<Array<MCSectionSchema> | undefined> {
        return this.select(s => s.fieldsSchema);
    }

    setFieldsSchema(fieldsSchema: Array<MCSectionSchema>) {
        this.updateState('[Declarations Details MCStore Service] set fieldsSchema', { fieldsSchema: fieldsSchema })
    }
}